import { render, staticRenderFns } from "./TankSidebar.vue?vue&type=template&id=72228dea&scoped=true"
import script from "./TankSidebar.vue?vue&type=script&lang=js"
export * from "./TankSidebar.vue?vue&type=script&lang=js"
import style0 from "./TankSidebar.vue?vue&type=style&index=0&id=72228dea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72228dea",
  null
  
)

export default component.exports